module.exports = __webpack_public_path__ + "static/img/loding.35f0794.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loding.gif
// module id = JV7o
// module chunks = 0